import Vue from 'vue';
import elementUI from 'element-ui';
import Clipboard from 'v-clipboard';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/reset.css';
import '@/assets/styles/global.css';
import '@/assets/styles/elementUi.css';
import { registerGlobal } from '@/utils/env';
import $http from '@/page/plugins/$http';
import $dialog from '@/page/plugins/$dialog';
import App from './App.vue';
import createRouter from '@/page/router';
import locale from 'element-ui/lib/locale/lang/zh-CN'
import { Popup, DatetimePicker, Picker } from 'vant'
import VueAMap, { initAMapApiLoader } from '@vuemap/vue-amap';
import 'vant/lib/index.css';
import '@vuemap/vue-amap/dist/style.css';
import permission from '@/directives/permission'
Vue.use(permission)

Vue.use(elementUI, { locale, size: 'small'})

Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Picker)

Vue.config.devtools = true
Vue.use(elementUI);
Vue.use($http);
Vue.use($dialog);
Vue.use(Clipboard);

// 高德地图组件
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'f92419d61f71564069953c5c5e8c0b5f',
  securityJsCode: '44d83124377f5540de04cb92f0ceaedb',
  plugins: ['AMap.Geocoder', 'AMap.Marker']
});

// 全局注册可复用组件
registerGlobal(
  require.context('./page/component/ui', false, /\.vue$/),
  inst => Vue.component(inst.name, inst)
);
// 全局注册mixin
registerGlobal(
  require.context('./page/mixins', false, /\.js$/),
  inst => Vue.mixin(inst)
);

Vue.config.productionTip = false;
new Vue({
  router: createRouter(
    require.context('./page/component/routes/', true, /\.vue$/)
  ),
  // store,
  render: h => h(App)
}).$mount('#app');
